var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.09808 5.65186H24.2258C24.6106 5.65186 24.9661 5.85772 25.158 6.1917L29.8567 14.3685C30.1003 14.7926 30.028 15.3278 29.6804 15.6716L16.7472 28.4674C16.3282 28.8819 15.6543 28.8819 15.2353 28.4674L2.31961 15.6889C1.96397 15.3371 1.89738 14.7863 2.15889 14.3596L7.1814 6.16546C7.377 5.84634 7.72411 5.65186 8.09808 5.65186ZM22.1434 9.30253V11.5968H17.5493V13.1875C20.7759 13.3575 23.1967 14.0557 23.2147 14.8925L23.2146 16.6371C23.1966 17.4739 20.7759 18.172 17.5493 18.342V22.2458H14.4987V18.342C11.2721 18.172 8.85125 17.4739 8.83333 16.6371L8.83339 14.8925C8.85137 14.0557 11.2721 13.3575 14.4987 13.1875V11.5968H9.90454V9.30253H22.1434ZM16.024 17.1435C19.4674 17.1435 22.3454 16.5532 23.0498 15.7648C22.4525 15.0963 20.292 14.5701 17.5493 14.4256V16.0911C17.0577 16.117 16.5474 16.1306 16.024 16.1306C15.5006 16.1306 14.9903 16.117 14.4987 16.0911V14.4256C11.7559 14.5701 9.59547 15.0963 8.99819 15.7648C9.70252 16.5532 12.5806 17.1435 16.024 17.1435Z",
    fill: "#009393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/USDT.d8dbe3cf995e28670ee410d612693840.svg";
export { ForwardRef as ReactComponent };